import { getAppConfig } from '../util/util'

export default (block, modifier) => {
  const config = getAppConfig()
  const defaultClass = config[block] || block

  const bemClass = function (element = '', overrideModifier = '') {
    const classes = []

    classes.push(defaultClass + (element ? `__${element}` : ''))

    if (overrideModifier) {
      classes.push(`${classes[0]}--${overrideModifier}`)
    } else if (!element && modifier.value) {
      classes.push(`${classes[0]}--${modifier.value}`)
    }

    return classes
  }

  return {
    bemClass
  }
}
